import { Component, inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NotificationService } from '../../../services/notification.service';
import { UserManagementService } from '../../../services/user-management.service';
import { StorageService } from '../../../services/storage.service';
import { AuthUserProfile } from '../../../store/entities/uaa/auth-user.model';
import { filter, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-corporate-landing',
  templateUrl: './corporate-landing.component.html',
  styleUrls: ['./corporate-landing.component.scss'],
  standalone: false,
})
export class CorporateLandingComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly notificationService = inject(NotificationService);
  private readonly uaaService = inject(UserManagementService);
  private readonly storageService = inject(StorageService);

  isSidebarOpen = false;
  activeMenu = 'today-trends';
  isCorporateReader = false; 
  isPersonalUser = false;


  private async loadUserProfile(): Promise<AuthUserProfile | null> {
    try {
      const authUser = await this.uaaService.getUserProfileAndRoles();
      console.log('User profile loaded', authUser);
      return authUser;
    } catch (error: any) {
      this.notificationService.errorMessage(
        error?.message || 'Failed to load user profile'
      );
      return null;
    }
  }



async ngOnInit(): Promise<void> {

  const authUser = await this.loadUserProfile();

if (authUser) {
  const userType = (authUser.userType || '').toUpperCase();
  const roles = (authUser.role || []).map((r: any) => r.name?.toUpperCase() || '');

  const isCorporate = userType === 'CORPORATE';
  const hasReader = roles.includes('CORPORATE_READER');
  const hasAdmin = roles.includes('CORPORATE_ADMINISTRATOR');

  // Hide admin menus ONLY if user is corporate reader with NO admin rights
  this.isCorporateReader = isCorporate && hasReader && !hasAdmin;
    this.isPersonalUser = userType === 'PERSONAL';
}


  const currentUrl = this.router.url;


  const shouldRedirectToTrends =
    currentUrl === '/corporate' ||
    currentUrl === '/corporate/' ||
    currentUrl === '/' ||
    (this.isCorporateReader && !currentUrl.includes('/today-trends'));

  if (shouldRedirectToTrends) {

    await this.router.navigate(['/corporate/today-trends'], { replaceUrl: true });
  }

 
  this.updateActiveMenuFromRoute();


  this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null) 
    )
    .subscribe(() => {
      this.updateActiveMenuFromRoute();
    });


  setTimeout(() => {
    if (this.activeMenu !== 'today-trends') {
      this.activeMenu = 'today-trends';
    }
  }, 100);
}

  private updateActiveMenuFromRoute(): void {
    const urlSegments = this.router.url.split('/').filter(segment => segment);
    
    if (urlSegments.length >= 2 && urlSegments[0] === 'corporate') {
      const menu = urlSegments[1];

      const validMenus = ['today-trends', 'billing', 'readers', 'subscription','payment'];
      this.activeMenu = validMenus.includes(menu) ? menu : 'today-trends';
    } else {
      this.activeMenu = 'today-trends';
    }
  }
isActive(menu: string): boolean {
  return this.activeMenu === menu;
}
  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  setActiveMenu(menu: string): void {
    this.activeMenu = menu;
    this.router.navigate(['/corporate', menu]);
  }
}